/** Must match Backend/src/config/focusAttributes.js (FOCUS_OTHER_ATTRIBUTE_ID) */
export const FOCUS_OTHER_ATTRIBUTE_ID = 40;
